import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import Const from 'constants';
import {Storage} from 'storages/storage';
import BaseLineup from 'services/sports/default/base-lineup';
import {getLpService} from 'services/sports/factory';

export default class LineupClassic extends BaseLineup {
    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig, runSettings} = Action.getState();
        const flexPositions = sportConfig.getConfigProp('flexPlayerPositionName');
        const lpService = getLpService(sportConfig, {store: new Storage()});
        const optimizationConfig = runSettings.getRunSettingsByKey(
            lpService.exec('createRunSettingsFlexPositionsKey', {lineupId}),
        );

        const constraint = {
            [Const.POSITION_FLEX]: lpService.exec('getForbiddenFlexMaxExposurePositions', {
                optimizationConfig,
                positionName: Const.POSITION_FLEX,
            }),
            [Const.POSITION_SUPERFLEX]: lpService.exec('getForbiddenFlexMaxExposurePositions', {
                optimizationConfig,
                positionName: Const.POSITION_SUPERFLEX,
            }),
        };

        const {canPlayerBeSetOnPositionFunctions = []} = this.exec(
            'getFunctionsToSetPlayersByColumns',
            {
                lineupId,
            },
            {},
        );

        canPlayerBeSetOnPositionFunctions.push((player, position) => {
            return !(
                inArray(position.alias, flexPositions) &&
                constraint[position.alias] &&
                constraint[position.alias].hasOwnProperty(player.positionName)
            );
        });

        const params = {
            team,
            sportConfig,
            functions: {
                canPlayerBeSetOnPositionFunctions,
            },
        };

        let players = PositionInLineup.set.inDependenceOnDistribution(params);

        if (!isEmpty(players) && !sportConfig.isModeLateswap()) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.POSITION_FLEX, Const.POSITION_SUPERFLEX],
            });
        }

        players.map(function (player) {
            player.positionInLineupRaw = player.positionInLineup;
            if (player.positionInLineup === Const.POSITION_SUPERFLEX) {
                player.positionInLineup = Const.POSITION_CFB_NAMES[sportConfig.getSite()][Const.POSITION_SUPERFLEX];
                player.positionInLineupRaw = Const.POSITION_SUPERFLEX;
            }
        });

        return [...players];
    }
}
